<template>
    <div v-if="$auth.role.includes('SuperAdmin')">
        <v-menu min-width="250" offset-y v-model="menuOpen">
            <template #activator="{ on, attrs }">
                <v-btn small v-bind="attrs" v-on="on" outlined class="d-flex align-center secondary-btn">
                    <span> Admin </span>
                    <font-awesome-icon class="ml-2" icon="fa-regular fa-wrench"></font-awesome-icon>
                </v-btn>
            </template>
            <v-card class="p-2">
                <v-row>
                    <v-col class="px-1 py-0">
                        <v-list>
                            <v-list-item>
                                <v-btn
                                    class="tribute-btn"
                                    color="#c1c1c1"
                                    block
                                    depressed
                                    @click="openPanel('tributeSuper')"
                                >
                                    <v-icon left>mdi-card-account-details</v-icon>
                                    Tribute
                                </v-btn>
                            </v-list-item>
                            <v-list-item>
                                <v-btn 
                                    class="tribute-btn" 
                                    color="#c1c1c1" 
                                    block 
                                    depressed
                                    @click="openPanel('eventSuper')"
                                >
                                    <v-icon left>mdi-calendar-text</v-icon>
                                    Event
                                </v-btn>
                            </v-list-item>
                            <v-list-item v-if="standardRenderId">
                                <v-btn
                                    class="tribute-btn"
                                    color="#c1c1c1"
                                    block
                                    depressed
                                    @click="openPanel('standardRenderSuper')"
                                >
                                    <v-icon left>mdi-video</v-icon>
                                    <span> Original Render </span>
                                </v-btn>
                            </v-list-item>

                            <v-list-item v-if="publicRenderId">
                                <v-btn
                                    class="tribute-btn"
                                    color="#c1c1c1"
                                    block
                                    depressed
                                    @click="openPanel('publicRenderSuper')"
                                >
                                    <v-icon left>mdi-video-wireless</v-icon>
                                    Public Render
                                </v-btn>
                            </v-list-item>
                            <v-list-item>
                                <v-btn
                                    class="tribute-btn"
                                    color="#c1c1c1"
                                    block
                                    depressed
                                    @click="openPanel('changelogSuper')"
                                >
                                    <v-icon left>mdi-format-list-group</v-icon>
                                    Changelog
                                </v-btn>
                            </v-list-item>
                            <v-list-item>
                                <v-btn
                                    class="tribute-btn"
                                    color="#c1c1c1"
                                    block
                                    depressed
                                    @click="openPanel('ingestPipelineSuper')"
                                >
                                    <v-icon left>mdi-server-network</v-icon>
                                    Processing Photos
                                </v-btn>
                            </v-list-item>
                        </v-list>
                    </v-col>
                    <v-col class="px-1 py-0">
                        <v-list>
                            <v-list-item>
                                <v-btn
                                    class="tribute-btn"
                                    color="#c1c1c1"
                                    block
                                    depressed
                                    @click="shareLinkModalOpen = !shareLinkModalOpen"
                                >
                                    <v-icon left>mdi-link-variant</v-icon>
                                    Share Links
                                </v-btn>
                            </v-list-item>
                            <v-list-item>
                                <v-btn
                                    class="tribute-btn"
                                    color="#c1c1c1"
                                    block
                                    depressed
                                    @click="contributorDetailModalOpen = !contributorDetailModalOpen"
                                >
                                    <v-icon left>mdi-account-group</v-icon>
                                    Contributors Table</v-btn
                                >
                            </v-list-item>
                            <v-list-item>
                                <CustomTooltip :tooltipProps="{ bottom: true }" style="flex: 1;">
                                    <template #activator>
                                        <v-btn
                                            class="tribute-btn"
                                            color="#c1c1c1"
                                            block
                                            depressed
                                            @click="toggleDebugTools"
                                        >
                                            <v-icon left>mdi-bug</v-icon>
                                            {{state.debugInfoEnabled ? 'Disable' : 'Enable'}} Debug Tools
                                        </v-btn>
                                    </template>

                                    <template #content>
                                        <span>Add <span style="background: #dedede;" class="px-1">?enable-debug-info</span> 
                                            to the end of a tribute url, to use outside of admin tools.  
                                        </span>
                                    </template>
                                </CustomTooltip>
                            </v-list-item>
                        </v-list>
                    </v-col>
                </v-row>
            </v-card>
        </v-menu>

        <TributePanelSuper ref="tributeSuper" v-if="tributeId" :eventId="tributeEventId" />
        <EventPanelSuper ref="eventSuper" v-if="tributeEventId" :eventId="tributeEventId" />

        <ChangelogPanel
            ref="changelogSuper"
            v-if="tributeId"
            :tributeVideoId="tributeId"
            @init-rerender="$emit('init-rerender')"
        />
        <TributeRenderPanelSuper
            ref="standardRenderSuper"
            v-if="standardRenderId"
            :tributeRenderId="standardRenderId"
        />
        <TributeRenderPanelSuper ref="publicRenderSuper" v-if="publicRenderId" :tributeRenderId="publicRenderId" />

        <IngestPipelinePanel ref="ingestPipelineSuper" v-if="tributeEventId" :eventId="tributeEventId" />

        <ShareLinkModalSuper v-model="shareLinkModalOpen"></ShareLinkModalSuper>

        <ContributorDetailsModalSuper v-model="contributorDetailModalOpen" />
    </div>
</template>
<script>
import TributePanelSuper from '../AdminPanels/TributePanelSuper.vue';
import EventPanelSuper from '../AdminPanels/EventPanelSuper.vue';
import ChangelogPanel from '@/components/Tribute/Layout/ChangelogPanel.vue';
import TributeRenderPanelSuper from '../AdminPanels/TributeRenderPanelSuper.vue';
import IngestPipelinePanel from '../AdminPanels/IngestPipelinePanel.vue';
import ShareLinkModalSuper from '../AdminPanels/ShareLinkModalSuper.vue';
import ContributorDetailsModalSuper from '../AdminPanels/ContributorDetailsModalSuper.vue';
import CustomTooltip from '../../ui/CustomTooltip.vue';
import { useTributeVideoStore } from '@/stores/tributeVideo';
export default {
    setup() {
        return {
            tributeVideoStore: useTributeVideoStore(),
        }
    },
    data() {
        return {
            menuOpen: false,
            shareLinkModalOpen: false,
            debugToolsEnabled: false,
            contributorDetailModalOpen: false
        };
    },
    inject: ['tributeRender', 'state'],
    components: {
        TributePanelSuper,
        EventPanelSuper,
        ChangelogPanel,
        TributeRenderPanelSuper,
        IngestPipelinePanel,
        ShareLinkModalSuper,
        CustomTooltip,
        ContributorDetailsModalSuper,
    },
    computed: {
        tributeId() {
            return this.tributeVideoStore.id;
        },
        tributeEventId() {
            return this.tributeVideoStore.eventId;
        },
        standardRenderId() {
            return this.tributeRender?.standardRender?.id || null;
        },
        publicRenderId() {
            return this.tributeRender?.publicRender?.id || null;
        },
    },
    methods: {
        openPanel(panel) {
            const ref = this.$refs[panel];

            if (ref && typeof ref.togglePanel === 'function') {
                ref.togglePanel();
            }
        },
        toggleDebugTools() {
            this.$root.$emit('enableDebugInfo', !this.state.debugInfoEnabled);
        }
    },
};
</script>

<style lang="scss" scoped>
.tribute-btn {
    @include tribute-btn(#ff530d, $textColor: white);
}

.secondary-btn {
    @include tribute-btn(white);
}
</style>
